import { handleActions, combineActions } from "redux-actions";
import * as Immutable from "immutable";

import * as Actions from "./readingActions";
import { userLogoutReceived } from "../../../security";
import { setReadingLocation } from "./readingActions";

const initialState: Immutable.Map<string, any> = Immutable.fromJS({
  isFetchingData: false,
  error: null,
  readingValues: [],
  locationId: ""
});

//is action payload immutable?
const readingReducer = handleActions(
  {
    [Actions.fetchReadingRequested](state) {
      return state.set("isFetchingData", true);
    },
    [Actions.fetchReadingReceived](state, action) {
      return state
        .set("isFetchingData", false)
        .set("error", null)
        .set("readingValues", Immutable.fromJS(action.payload));
    },
    [Actions.fetchReadingFailed](state, action) {
      return state.set("isFetchingData", false).set("error", action.payload);
    },
    [Actions.approveMetersFailed](state, action) {
      return state.set("error", action.payload);
    },
    // [combineActions(
    //   Actions.fetchReadingFailed,
    //   Actions.bulkSetreadingValuesFailed
    // )](state, action) {
    //   return state.set("error", action.payload);
    // },
    [userLogoutReceived](state, action) {
      return initialState;
    },
    [setReadingLocation](state, action) {
      return state.set("locationId", action.payload);
    }
    // [Actions.setreadingValuesReceived](state, action) {
    //   const { model, ahriCertification, readingValues } = action.payload;
    //   return state.update("readingValues", values => {
    //     const index = values.findIndex(cop => {
    //       return cop.get("model") === model;
    //     });
    //     return values.update(index, value => {
    //       return (
    //         value &&
    //         value
    //           .set("ahriCertification", ahriCertification)
    //           .set("readingValues", Immutable.fromJS(readingValues))
    //       );
    //     });
    //   });
    // }
  },
  initialState
);

export { readingReducer };
export default readingReducer;



// WEBPACK FOOTER //
// ./src/features/reading/store/readingReducer.js